import {
  createAsyncThunk,
  createDraftSafeSelector,
  createSlice,
} from "@reduxjs/toolkit";
import {
  addErrorNotification,
  addNotification,
} from "redux/system/system-action-creators";
import ApiService from "./../../services/apiService";
import { toIsoDate } from "core/utilities/date-service";

const initialState = {
  loading: false,
  redirectTo: "",
};

// ---------------
// Action Thunks
// ---------------
export const changeSubscription = createAsyncThunk(
  "changeSubscriptionAdmin/changeSubscription/change",
  async (data, thunkAPI) => {
    try {
      const { userId, values, onPaymentCompleted } = data;

      let payload = {
        userId,
        productCode: values.selectedPlan?.value,
        nextBillingDate: toIsoDate(values.nextBillingDate),
      };

      await ApiService().updateSubscription(userId, payload);

      thunkAPI.dispatch(
        addNotification("Subscription has been successfully changed.")
      );

      onPaymentCompleted();

      return true;
    } catch (err) {
      thunkAPI.dispatch(
        addErrorNotification(err, "Unable to change subscription.")
      );
      throw err;
    }
  }
);

// ------------
// Slice
// ------------
export const manageSubscriptionAdminChangeSubsSlice = createSlice({
  name: "changeSubscriptionAdmin/changeSubscription",
  initialState,
  reducers: {
    clearStates: (state) => {
      //state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changeSubscription.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(changeSubscription.fulfilled, (state) => {
      state.loading = false;
    });

    builder.addCase(changeSubscription.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { clearStates } = manageSubscriptionAdminChangeSubsSlice.actions;

export default manageSubscriptionAdminChangeSubsSlice.reducer;

// ------------
// Selectors
// ------------
const selectSelf = (state) => state.manageSubscriptionAdminChangeSubs;

export const selectManageSubscriptionAdminChangeSubs = createDraftSafeSelector(
  selectSelf,
  (state) => state
);
